// extracted by css-extract-rspack-plugin
export default {"cls1":"RatingCard-cls1_2S_","cls2":"RatingCard-cls2_KDx RatingCard-cls1_2S_"};